import { Field, Form, Formik } from 'formik'
import React from 'react'
import { useAckTermsAndConditions } from '../../api/account/apiRegistration'
import { Button } from '../../genericComponents/Button'
import { Card } from '../../genericComponents/Card'
import { Note } from '../../genericComponents/Note'
import { useQueryClient } from '@tanstack/react-query'
import { INPUT_FORM_COMMON_SIZE } from '../../genericComponents/OverlayWrapper'

export const TermAndConditionCard: React.FC = () => {
  const { mutateAsync: ackTerms } = useAckTermsAndConditions()
  const queryClient = useQueryClient()

  const handleSubmit = (_values: { termsAndConditions: boolean }) => {
    void ackTerms().then(() => {
      void queryClient.invalidateQueries({ queryKey: ['registrationState'] })
    })
  }

  return (
    <Card title="">
      <h1 className="text-primary font-bold text-2xl uppercase text-center tracking-widest">
        Welcome to HMD Softlock
      </h1>
      <div className={'m-6 text-base' + INPUT_FORM_COMMON_SIZE}>
        <p className="mt-8">
          Almost there! There are few more steps you need to complete before we can sign you in.
        </p>
        <p className="mt-4">
          Before we start, you need to agree to our B2B Privacy Policy, then select Continue to
          setup your account.
        </p>
        <Formik initialValues={{ termsAndConditions: false }} onSubmit={handleSubmit}>
          {({ isSubmitting, values, handleChange }) => (
            <Form>
              <div className="flex items-center mt-4">
                <Field
                  type="checkbox"
                  name="termsAndConditions"
                  className="w-4 mr-2.5 softlock-new box-border border border-borderColor min-h-12 max-w-[500px] border-solid"
                  checked={values.termsAndConditions}
                  onChange={handleChange}
                />
                <Note>
                  I confirm that I have read and agree to the{' '}
                  <a href="https://www.hmd.com/en_int/privacy" target="_blank">
                    B2B Privacy Policy
                  </a>
                  .
                </Note>
              </div>
              <Button
                type="submit"
                className="w-full bg-primaryButtonColor text-white mt-6 uppercase"
                disabled={!values.termsAndConditions || isSubmitting}
              >
                CONTINUE
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </Card>
  )
}
